import { style } from 'styled-system'

export const textDecoration = style({
  prop: 'textDecoration',
  cssProperty: 'textDecoration',
})

export const textDecorationColor = style({
  prop: 'textDecorationColor',
  cssProperty: 'textDecorationColor',
})



// WEBPACK FOOTER //
// ./src/utils/styled-system-extras.js